import { Component, input } from '@angular/core';
import { MediaService } from '@app/services/media.service';

@Component({
    selector: 'clever-menu2-item',
    templateUrl: './menu2-item.component.html',
    styleUrls: ['./menu2-item.component.scss'],
    standalone: false
})
export class Menu2ItemComponent  {
    menu = input<any>(null);
    constructor(
        protected mediaService: MediaService
    ) {
    }
}
